import { HomeMenuThemeModeConfig } from './types';

const light: HomeMenuThemeModeConfig = {
  HomeMenu: {
    backgroundColor: '#0775bc',
    borderColor: 'none',
    textColor: '#ffffff',
    backgroundIconColor: '#0775bc'
  },
};

export default light;
